<template>
    <section class="mx-2 my-4" :aria-labelledby="reviewTitleId">
        <BaseCard theme="cream" padding="none" radius="lgr" class="@container w-full min-w-0 max-w-[600px] overflow-hidden md:w-full">
            <div :aria-label="t('chat.developmentGoal.review.detailsLabel')" class="flex flex-col gap-4 px-6 pt-6 pb-5">
                <FeatureChip feature="journeys" class="w-fit">{{ t("chat.developmentGoal.review.newJourney") }}</FeatureChip>
                <div class="flex flex-col gap-1">
                    <h2 :id="reviewTitleId" class="nadia-chat-bold text-pretty text-ink">{{ goal.title }}</h2>
                    <p class="body-small text-ink-muted">{{ goal.achievement_criteria }}</p>
                    <p v-if="isSuperseded" :id="supersededDescriptionId" class="scaffold-details-small mt-1 text-ink-muted">
                        {{ t("chat.developmentGoal.review.superseded") }}
                    </p>
                </div>
            </div>
            <div class="flex flex-col gap-2 border-t border-border py-3 pr-3 pl-6 @sm:flex-row @sm:items-center @sm:justify-between">
                <I18nT v-if="goal.target_date" keypath="chat.developmentGoal.review.targetDate" tag="p" class="scaffold-details-small text-ink-muted">
                    <template #date><BaseDate :value="goal.target_date" format="date-long" /></template>
                </I18nT>
                <BaseButton
                    theme="primary"
                    size="sm"
                    class="shrink-0 self-stretch @sm:ml-auto @sm:self-auto"
                    :disabled="!canSave || isSaving || isSaved"
                    :aria-describedby="isSuperseded ? supersededDescriptionId : undefined"
                    @click="emit('save')">
                    {{
                        isSaving
                            ? t("chat.developmentGoal.review.saving")
                            : isSaved
                              ? t("chat.developmentGoal.review.saved")
                              : (actionLabel ?? t("chat.developmentGoal.review.save"))
                    }}
                </BaseButton>
            </div>
        </BaseCard>
    </section>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import BaseDate from "~vue/components/BaseDate.vue";
import FeatureChip from "~vue/components/FeatureChip.vue";
import type { DevelopmentGoalDraft } from "~vue/types/chat";
import { useId } from "vue";
import { I18nT, useI18n } from "vue-i18n";

withDefaults(defineProps<{ goal: DevelopmentGoalDraft; actionLabel?: string; canSave?: boolean; isSuperseded?: boolean; isSaving?: boolean; isSaved?: boolean }>(), {
    canSave: true,
    isSuperseded: false,
    isSaving: false,
    isSaved: false,
});

const emit = defineEmits<{ save: [] }>();
const { t } = useI18n();
const reviewTitleId = useId();
const supersededDescriptionId = useId();
</script>
